document.querySelectorAll('.Athletes_co-owner_product_slider').forEach((slider) => {
    new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        direction: 'horizontal',
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: slider.querySelector('.swiper-pagination'),
            type: 'fraction',
            formatFractionCurrent: function (number) {
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                return number < 10 ? '0' + number : number;
            }
        },
        scrollbar: {
            el: slider.querySelector('.swiper-scrollbar'),
            draggable: true,
        }
    });
});